import React from "react";
import { useStyles } from "./style";
import { FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";

const InputGroupComponent = ({ textFieldLabel, textFieldType, menuItems, textFieldValue, selectFieldValue, onChange, textFieldName, selectFieldName, selectFieldPosition = "end", ...props }) => {
  const classes = useStyles({ selectFieldPosition });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const inputGroupValues = {
      textFieldValue: name === textFieldName ? value : textFieldValue,
      selectFieldValue: name === selectFieldName ? value : selectFieldValue,
    };
    onChange(name, value, inputGroupValues);
  };

  const adornment = (
    <InputAdornment position={selectFieldPosition}>
      <Select
        variant="standard"
        name={selectFieldName}
        value={selectFieldValue || ""}
        onChange={handleInputChange}
        disableUnderline
        className={classes.selectAdornment}
        disabled={props.disabled}
        size="small"
      >
        {menuItems.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </InputAdornment>
  );

  return (
    <FormControl variant="outlined" fullWidth >
      <InputLabel htmlFor={props.inputFieldId} className={classes.inputLabel} size="small">
        {textFieldLabel}
      </InputLabel>
      <OutlinedInput
        id={props.inputFieldId}
        value={textFieldValue || ""}
        onChange={handleInputChange}
        label={textFieldLabel}
        name={textFieldName}
        inputProps={props.inputProps}
        type={textFieldType}
        {...(selectFieldPosition === "start" ? { startAdornment: adornment } : { endAdornment: adornment })}
        className={classes.textField}
        disabled={props.disabled}
        size="small"
      />
    </FormControl>
  );
};

export default InputGroupComponent;
